import { FocusedOption } from "../store/reducers/visualizer";
import { CloudStreamVisualizerState, CustomWrap, VisualizerConfiguration, ZLVEVisualizerState as ZLVEVisualizerState } from "../types/VisualizerTypes";

export function reduceZLVEState(previous: ZLVEVisualizerState, current: Partial<ZLVEVisualizerState>){
    const result:ZLVEVisualizerState = {
        ...previous,
        ...current,
        animationStates: {
            ...previous.animationStates,
            ...(current.animationStates ?? {}),
        },
        instantAnimations: {
            ...previous.instantAnimations,
            ...(current.instantAnimations ?? {}),
        },
        forceAnimationStates: {
            ...previous.forceAnimationStates,
            ...(current.forceAnimationStates ?? {}),
        },
        prcodes: [
            ...previous.prcodes,
            ...(current.prcodes ?? []),
        ]
    }
    return result;
}

export function reduceCloudStreamState(previous: CloudStreamVisualizerState, current: Partial<CloudStreamVisualizerState>){
    const result:CloudStreamVisualizerState = {
        ...previous,
        ...current,
    }
    return result;
}

function getVisualizerStateReducer(visualizer: VisualizerConfiguration)
{
    if ("cloudStreamOptions" in visualizer)
    {
        return reduceCloudStreamState
    }
    else
        return reduceZLVEState;
}

export function composeState(visualizer: VisualizerConfiguration, selection: Record<string, string[]>, wrapPreview: CustomWrap | undefined, focusedOption: FocusedOption | undefined)
{
    return composeVisualizerState(visualizer.initialState, visualizer.configuration.optionsGroups, selection, wrapPreview, focusedOption, getVisualizerStateReducer(visualizer) as never)
}

export function composeVisualizerState<TState extends ZLVEVisualizerState | CloudStreamVisualizerState>(initial: TState, groups: VisualizerConfiguration["configuration"]["optionsGroups"], selection: Record<string, string[]>, wrapPreview: CustomWrap | undefined, focusedOption: FocusedOption | undefined, reducer: (previous: TState, current: Partial<TState>) => TState)
{
    let visualizerState : TState = {...initial, forceAnimationStates: Object.keys(initial.animationStates as Record<string, number>).reduce((s, a) => Object.assign(s, {[a]: 0}), {})};
    for (const groupID in selection)
    {
        for (const optionID of selection[groupID] ?? [])
        {
            const option = groups[groupID]?.options[optionID];
            visualizerState = reducer(visualizerState, (option?.visualizerState ?? {}) as Partial<TState>);
        }
    }

    if (focusedOption && focusedOption.option?.focusedVisualizerState)
    {
        visualizerState = reducer(visualizerState, (focusedOption.option?.focusedVisualizerState ?? {}) as Partial<TState>);
    }

    if(wrapPreview) {
        visualizerState = reducer(visualizerState, ({preview: [`custom_${wrapPreview.finish}`, `custom_${wrapPreview.finish}__D(${wrapPreview.diffuse.r}:${wrapPreview.diffuse.g}:${wrapPreview.diffuse.b})__S(${wrapPreview.specular.r}:${wrapPreview.specular.g}:${wrapPreview.specular.b})`]}) as Partial<TState>)
    }
    if((visualizerState.prcodes as string[])?.includes("!EA015_20_OC")) {
        visualizerState.prcodes = (visualizerState.prcodes as string[]).filter(p => !p.includes("EA015_20_OC"))
    }

    /* Generate alternative PRCodes for slatelets to position them sequentially */

    return visualizerState;
}